<ng-container *ngIf="isColorAvailable()">
  <div class="vehicle-colors"  [ngStyle]="{'width.px': width, 'height.px': height}">
    <div class="base-{{ color | lowercase }}">
      <div class="shade-{{ color | lowercase }}" [ngStyle]="{'border-left-width.px': width}">
      </div>
    </div>
  </div>
</ng-container>
